import React from "react";

interface TextProps extends React.HTMLAttributes<HTMLElement>{    
  text?: string | undefined
}

class Title extends React.Component<TextProps> {
  render() {
    if (!this.props.hidden)
    return (
      <div
        {...this.props}
      >
        {this.props.text}
      </div>
    );
  }
}

export default Title;